// @flow
export type SignUpIndividualActionType = {|
  type: 'SIGNUP_SET_INDIVIDUAL_CONTACT_MEDIUMS_STATUS',
  payload: {|
    status: boolean,
  |},
|};

export const signUpSetIndividualContactMediumsStatus = (status: boolean): SignUpIndividualActionType => ({
  type: 'SIGNUP_SET_INDIVIDUAL_CONTACT_MEDIUMS_STATUS',
  payload: { status },
});
